module.exports = __webpack_public_path__ + "img/small.2171b9c7.jpg";